export default __webpack_public_path__ + "static/media/core-remove-tab.70371d72.svg";